<div
  class="modal fade"
  bsModal
  [config]="{
    backdrop: backdrop,
    keyboard: backdrop !== 'static',
    ignoreBackdropClick: true,
  }"
  tabindex="-1"
  role="dialog"
  (onHidden)="close()"
>
  <div
    class="modal-dialog"
    role="document"
    [ngClass]="{
      'modal-xs': size === 'tiny',
      'modal-sm': size === 'small',
      'modal-md': size === 'medium',
      'modal-lg': size === 'large',
    }"
  >
    @if (isOpen) {
      <ng-content select=".modal-content"></ng-content>
    }
  </div>
</div>
